import styled from "styled-components"

export const Global = styled.div` 
    background: #F0F0F0;
    min-height: 100vh;
`